import React from 'react';
import cn from 'classnames';

import Button from '../../../common/ui/Button';
import Modal from '../../../common/ui/Modal';
import Loader from '../../../common/ui/Loader';
import QuestionIcon from '../../../../assets/icons/common/QuestionIcon';
import WarningIcon from '../../../../assets/icons/common/WarningIcon';

import styles from './styles.module.scss';

const DeviceReactivatioModal = ({
  submitHandler,
  isOpen,
  onClose,
  isLoading,
  costData,
  error,
}) => {
  const handleSubmit = async () => {
    await submitHandler();
    onClose();
  };
  const total = costData?.total || '';
  const subscriptionPrice = costData?.price || '';
  const prorationPrice = costData?.proration || '';
  const estimatedTax =
    typeof costData?.estimatedTax === 'undefined' ? '' : costData.estimatedTax;

  const showLoading = isLoading && !costData && !error;
  const showContent = !isLoading && costData && !error;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      className={cn(styles.baseModal, styles.reactivateModal)}
    >
      <div className={styles.iconWrapper}>
        <WarningIcon />
      </div>
      <h3 className={cn('h3', styles.title)}>Subscription Reactivation</h3>
      <div className={styles.reactivateModalContent}>
        {showLoading && (
          <div className={styles.loaderDescription}>
            We`re processing your reactivation request.
            <br />
            This may take a few moments.
            <div className={styles.loaderWrapper}>
              <Loader className={styles.deviceSidebarLoader} show={isLoading} />
            </div>
          </div>
        )}
        {error && (
          <p className={styles.description}>
            We couldn't process your reactivation request. Please, contact
            customer support or try again later.
          </p>
        )}
        {showContent && (
          <div>
            <p className={styles.description}>
              Please settle your outstanding balance to reactivate your
              subscription.
            </p>
            <div className={styles.line}>
              <span>
                Monthly Internet Subscription
                <i> Includes internet plan and other applicable fees</i>
              </span>
              <span>${subscriptionPrice}</span>
            </div>
            {prorationPrice ? (
              <div className={styles.line}>
                <span>Outstanding Usage (Prorated)</span>
                <span>${prorationPrice}</span>
              </div>
            ) : null}
            <div className={styles.line}>
              <div className={styles.estimatedTax}>
                Estimated Tax
                <div className={styles.tooltip}>
                  <QuestionIcon />
                  <span className={styles.tooltipText}>
                    The tax amount shown is an estimate. You`ll receive your
                    final tax and total via email or text once your payment is
                    processed.
                  </span>
                </div>
              </div>
              <span>${estimatedTax}</span>
            </div>
            <div className={styles.divider}></div>
            <div className={cn(styles.line, styles.lineTotal)}>
              <span>Total Amount Due</span>
              <span>${total}</span>
            </div>
          </div>
        )}
      </div>
      <div className={styles.reactivateModalFooter}>
        <Button
          className={styles.button}
          onClick={handleSubmit}
          isLoading={isLoading}
          disabled={error}
        >
          Proceed to Reactivate
        </Button>
      </div>
    </Modal>
  );
};
export default DeviceReactivatioModal;
